var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgEdit(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 31 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M24.416 2.766h-.047a1.103 1.103 0 00-1.547 0l-1.406 1.359 2.203 2.203 1.36-1.406c.421-.422.421-1.125 0-1.594l-.563-.562zm-10.875 9.28c-.14.095-.234.282-.281.47l-.797 2.718 2.766-.75a.973.973 0 00.468-.28l6.328-6.329-2.156-2.156-6.328 6.328zm7.688-10.874a3.338 3.338 0 014.734 0l.61.61a3.338 3.338 0 010 4.734l-9.282 9.28c-.375.376-.89.657-1.453.845l-4.688 1.312a.956.956 0 01-1.078-.281c-.328-.281-.422-.703-.328-1.078l1.36-4.688c.14-.562.468-1.078.843-1.453l9.282-9.281zM7.869 3h5.25c.61 0 1.125.516 1.125 1.125A1.11 1.11 0 0113.12 5.25H7.87a1.85 1.85 0 00-1.875 1.875v12.75c0 1.078.797 1.875 1.875 1.875h12.75a1.85 1.85 0 001.875-1.875v-5.25c0-.61.469-1.125 1.125-1.125.61 0 1.125.516 1.125 1.125v5.25A4.131 4.131 0 0120.62 24H7.87a4.101 4.101 0 01-4.125-4.125V7.125A4.131 4.131 0 017.87 3z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgEdit);
export default ForwardRef;
